import { useMemo, useState } from 'react';
import category from '~/assets/icons/category_2.svg';
import heart from '~/assets/icons/heart.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import sort from '~/assets/icons/sort.svg';
import takeAuction from '~/assets/icons/take_auction.svg';
import { Text } from '~/components/ui/Text';
import { Apps } from '~/shared';
import {
	setAuctionActiveFilter,
	setAuctionCategorySelectVisible,
	setAuctionModelFilter,
	setItemAuctionPageVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	AppAuctionFilter,
	AppAuctionPages,
	AppAuctionTypes,
	appAuctionFilterButtons,
} from '../AppAuction';
import { DefaultAppItemCard } from '../DefaultAppItemCard';
import { Select } from '../Select';
import {
	filterCarModelItems,
	filterClothesTypeItems,
	filterRealtyTypeItems,
	filterSelectItems,
	sortSelectItems,
} from './AppAuctionItemsPage.model';
import {
	StyledContainer,
	StyledCreateButton,
	StyledFiltersContainer,
	StyledHead,
	StyledHeadItemsContainer,
	StyledHeadTitleContainer,
	StyledItemsGrid,
} from './AppAuctionItemsPage.styled';

const AppAuctionItemsPage = () => {
	const dispatch = useLayoutDispatch();
	const activePage = useLayoutSelector(
		(state) => state.auction.activeAuctionPage,
	);
	const activeFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionFilter,
	);
	const activeCarModelFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionCarModelFilter,
	);
	const activeRealtyTypeFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionRealtyTypeFilter,
	);
	const activeClothesTypeFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionClothesTypeFilter,
	);
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const activeOtherTypeFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionBussinessTypeFilter,
	);
	const [sortValue, setSortValue] = useState<string | number | null>(null);

	const selectValue = useMemo(
		() => (activeFilter === AppAuctionFilter.Main ? null : activeFilter),
		[activeFilter],
	);

	return (
		<StyledContainer>
			<StyledHead>
				<StyledHeadItemsContainer>
					<StyledHeadTitleContainer
						style={{
							backgroundColor:
								activePage === AppAuctionPages.Favorites
									? '#C71E1E'
									: activePage === AppAuctionPages.MyBids
									? 'rgba(255, 255, 255, 0.05)'
									: '#FF1E00',
						}}
					>
						<img
							src={
								activePage === AppAuctionPages.Favorites
									? heart
									: activePage === AppAuctionPages.MyBids
									? takeAuction
									: appAuctionFilterButtons[activeFilter]?.icon
							}
						/>
						<Text>
							{activePage === AppAuctionPages.Favorites
								? 'Избранное'
								: activePage === AppAuctionPages.MyBids
								? 'Мои ставки'
								: appAuctionFilterButtons[activeFilter]?.name || ''}
						</Text>
					</StyledHeadTitleContainer>
				</StyledHeadItemsContainer>
				<StyledHeadItemsContainer>
					<StyledFiltersContainer>
						{activeFilter === AppAuctionFilter.Main && (
							<Select
								items={filterSelectItems}
								value={selectValue}
								placeholder={'Выбрать категорию'}
								onChange={(value) => {
									dispatch(setAuctionActiveFilter(value.value));
								}}
								icon={category}
								dropdownHeight="210px"
							/>
						)}
						{activeFilter === AppAuctionFilter.Vehicle && (
							<Select
								items={filterCarModelItems}
								value={activeCarModelFilter}
								placeholder={'Выберите марку'}
								onChange={(value) => {
									dispatch(
										setAuctionModelFilter({
											type: AppAuctionTypes.Vehicle,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAuctionFilter.Realty && (
							<Select
								items={filterRealtyTypeItems}
								value={activeRealtyTypeFilter}
								placeholder={'Выберите тип'}
								onChange={(value) => {
									dispatch(
										setAuctionModelFilter({
											type: AppAuctionTypes.Realty,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
							/>
						)}
						{activeFilter === AppAuctionFilter.Clothes && (
							<Select
								items={filterClothesTypeItems}
								value={activeClothesTypeFilter}
								placeholder={'Выберите тип'}
								onChange={(value) => {
									dispatch(
										setAuctionModelFilter({
											type: AppAuctionTypes.Clothes,
											value: value.value as string,
										}),
									);
								}}
								icon={category}
								dropdownHeight="160px"
							/>
						)}
						{activeFilter === AppAuctionFilter.Bussiness && <div />}
						<Select
							items={sortSelectItems}
							value={sortValue}
							placeholder={'Сортировать'}
							onChange={(value) => {
								setSortValue(value.value);
							}}
							icon={sort}
							dropdownHeight="110px"
						/>
					</StyledFiltersContainer>
					<StyledCreateButton
						onClick={() => dispatch(setAuctionCategorySelectVisible(true))}
					>
						<img src={plusRound} />
					</StyledCreateButton>
				</StyledHeadItemsContainer>
			</StyledHead>
			<StyledItemsGrid>
				{new Array(16).fill(0).map((_, i) => (
					<DefaultAppItemCard
						appType={Apps.Auction}
						type={
							i < 5
								? AppAuctionTypes.Vehicle
								: i < 10
								? AppAuctionTypes.Realty
								: i < 13
								? AppAuctionTypes.Clothes
								: AppAuctionTypes.Bussiness
						}
						price={100000}
						time={1234567890}
						key={i}
						participants={10}
						onClick={() => {
							dispatch(setItemAuctionPageVisible(true));
						}}
					/>
				))}
			</StyledItemsGrid>
		</StyledContainer>
	);
};

export { AppAuctionItemsPage };
